export default {
    API_URL: window.APPOINMENT_API_BASE_URL
}